import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductOverviewComponent } from './product-overview/product-overview.component';
import { CreateProductFormComponent } from './create-product-form/create-product-form.component';
import { ManageProductComponent } from './manage-product/manage-product.component';

const routes: Routes = [
  {
    path: 'products',
    component: ProductOverviewComponent
  },
  {
    path: 'products/create',
    component: CreateProductFormComponent
  },
  {
    path: 'products/:id',
    component: ManageProductComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductRoutingModule { }
